import React from 'react';
import { connect } from 'react-redux';

import ColoredSectionContainer from 'components/no-auth/common/ColoredSectionContainer';
import { LightButton } from 'components/no-auth/common/fromAuth/LightButton/LightButton';
import { LightFixedBottomPanel } from 'components/no-auth/common/fromAuth/LightFixedBottomPanel/LightFixedBottomPanel';
import { PromoIcon } from 'components/no-auth/common/promo-icon/PromoIcon';
import { PromoPageContainer } from 'components/no-auth/common/promo-page-container/PromoPageContainer';
import { PromoText } from 'components/no-auth/common/promo-text/PromoText';
import { PromoRow } from 'components/no-auth/common/PromoRow/PromoRow';
import HeadingSection from 'components/no-auth/common/sections/HeadingSection';
import { ZendeskHelpLink, ZendeskPromotedArticles } from 'components/no-auth/help/styles';
import ZendeskHelpSearch from 'components/no-auth/help/ZendeskHelpSearch';
import NotAuthBasePage from 'components/no-auth/NotAuthBasePage';

import { toggleChat } from 'actions/chatAction';

import { getLangCountryPrefix } from 'helpers/utils';

const ZendeskHelpPage = (props) => {
    const url = `${getLangCountryPrefix(props.lang, props.country)}/help`;

    const filteredCategories = props.categories?.filter((category) => {
        return !category.directLink;
    });

    const categories = filteredCategories?.map((item) => {
        return (
            <PromoRow indent="adaptive-24-32" key={item.id} lastChildNoMargin>
                <ZendeskHelpLink href={`${url}/category/${item.id}`}>
                    <PromoText variant="h3">{item.name}</PromoText>
                    <PromoIcon name="chevron-right" size="24px" />
                </ZendeskHelpLink>
            </PromoRow>
        );
    });

    const promotedArticles = props.promoted?.map((article) => {
        const section = props.sections?.find((s) => s.id === article.section_id);
        return (
            <PromoRow indent="adaptive-24-32" key={article.id} lastChildNoMargin>
                <ZendeskHelpLink href={`${url}/category/${section.category_id}/section/${article.section_id}/article/${article.id}`}>
                    <PromoText>{article.title}</PromoText>
                    <PromoIcon name="chevron-right" size="16px" />
                </ZendeskHelpLink>
            </PromoRow>
        );
    });

    return (
        <PromoPageContainer hasTopPadding>
            <ColoredSectionContainer dimension="average" bottomPadding noTopPadding>
                <ZendeskHelpSearch />
                <HeadingSection title={props.pageHeadline} titleTag={'h1'} />
                <PromoRow indent="adaptive-32-48-64">{categories}</PromoRow>
                {Array.isArray(promotedArticles) && promotedArticles > 0 && (
                    <ZendeskPromotedArticles>
                        <PromoRow indent="adaptive-32-48-64">
                            <PromoText tag={'h2'} variant={'h4'} textAlign={'center'}>
                                {props.promotedArticlesTitle}
                            </PromoText>
                        </PromoRow>
                        {promotedArticles}
                    </ZendeskPromotedArticles>
                )}
            </ColoredSectionContainer>
            {props.showZendeskChat && (
                <LightFixedBottomPanel pressedAboveCookieButton>
                    <LightButton raised={true} caption={props.chatButton} onClick={() => props.toggleChat(true)} />
                </LightFixedBottomPanel>
            )}
        </PromoPageContainer>
    );
};

const mapStateToProps = ({ extra }) => ({
    chatButton: extra?.strapiApi?.chat_btn,
    pageHeadline: extra?.strapiApi?.page_headline?.title,
    promotedArticlesTitle: extra?.strapiApi?.promoted_articles_title,
    categories: extra?.zendeskHelpData?.categories,
    sections: extra?.zendeskHelpData?.sections,
    promoted: extra?.zendeskHelpData?.promoted,
    lang: extra.noAuthFooter?.language?.lang,
    country: extra.noAuthFooter?.language?.country,
    showZendeskChat: extra?.noAuthFooter?.showZendeskChat,
});

export default connect(mapStateToProps, { toggleChat })(NotAuthBasePage(ZendeskHelpPage));
